export default "__VITE_ASSET__BWQ9nBuq__"